import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52084dc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-5" }
const _hoisted_2 = { class: "dialog-footer" }

import { ref, reactive, onMounted } from "vue";
import type { FormInstance } from "element-plus";
import type { UploadInstance, UploadProps, UploadRawFile } from "element-plus";
import { genFileId } from "element-plus";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import { creditAdjustTypeOptions } from "@/core/types/CreditAdjustTypes";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import BalanceShow from "@/components/BalanceShow.vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBatch',
  emits: ["fileUploaded"],
  setup(__props, { expose: __expose, emit }) {

const t = useI18n().t;
const modalRef = ref(false);
const isLoading = ref(false);
const ruleFormRef = ref<FormInstance>();
const submitSuccess = ref(false);
const successData = ref<any>({});
const uploaded = ref(true);
const rules = reactive<any>({
  serviceId: [
    { required: true, message: "Please select service", trigger: "blur" },
  ],
  type: [{ required: true, message: "Please select type", trigger: "blur" }],
  note: [{ required: true, message: "Please input note", trigger: "blur" }],
  file: [{ required: true, message: "Please upload file", trigger: "blur" }],
});
const formData = ref<any>({});
const tradeServices = ref<any>([]);

const uploadRef = ref<UploadInstance>();

const handleExceed: UploadProps["onExceed"] = (files) => {
  if (uploadRef.value) {
    uploadRef.value.clearFiles();
  } else {
    console.error("uploadRef.value is null or undefined");
  }
  const file = files[0] as UploadRawFile;
  file.uid = genFileId();
  if (file && uploadRef.value) {
    uploadRef.value.handleStart(file);
  } else {
    console.error("uploadRef.value is null or undefined");
  }
};

const submit = async (formEl: FormInstance | undefined) => {
  isLoading.value = true;

  try {
    await formEl?.validate(async (valid, fields) => {
      if (valid) {
        const form = new FormData();
        form.append("serviceId", formData.value.serviceId);
        form.append("type", formData.value.type);
        form.append("note", formData.value.note);
        if (formData.value.file) {
          const file = formData.value.file[0].raw;
          form.append("file", file);
        }
        const res = await PaymentService.uploadBatchFile(form);
        emit("fileUploaded");
        resetForm();
        successData.value = res;
        submitSuccess.value = true;
      }
    });
  } catch (e) {
    console.log(e);
    MsgPrompt.error("Submit failed");
    isLoading.value = false;
  }
  isLoading.value = false;
};

const resetForm = () => {
  ruleFormRef.value?.resetFields();
};


const show = () => {
  modalRef.value = true;
};
const process = async () => {
  isLoading.value = true;
  try {
    await PaymentService.confirmBatch(successData.value.adjustBatchId);
    emit("fileUploaded");
    MsgPrompt.success("Start process success");
  } catch (e) {
    MsgPrompt.error("Start process failed");
  }
  submitSuccess.value = false;
  modalRef.value = false;
  isLoading.value = false;
};
const close = () => {
  submitSuccess.value = false;
  modalRef.value = false;
};
const fecthData = async () => {
  isLoading.value = true;
  try {
    const res = await PaymentService.getTradeServices();
    tradeServices.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

onMounted(() => {
  fecthData();
});

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: modalRef.value,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((modalRef).value = $event)),
    title: _unref(t)('action.createBatch'),
    width: "800",
    "align-center": "",
    class: "rounded"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (modalRef.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (submit(ruleFormRef.value)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: formData.value,
          rules: rules,
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('title.service'),
              prop: "serviceId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.serviceId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.serviceId) = $event)),
                  clearable: "",
                  placeholder: _unref(t)('title.service'),
                  class: "w-150px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tradeServices.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.description,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.type'),
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
                  clearable: "",
                  placeholder: "Type",
                  class: "w-150px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(creditAdjustTypeOptions), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('fields.note'),
              prop: "note"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.note,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.note) = $event)),
                  autosize: { minRows: 2, maxRows: 4 },
                  type: "textarea"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('action.batchUpload'),
              prop: "file"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  ref_key: "uploadRef",
                  ref: uploadRef,
                  class: "upload-demo",
                  limit: 1,
                  "auto-upload": false,
                  "file-list": formData.value.file,
                  "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.file) = $event)),
                  "on-exceed": handleExceed
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { type: "primary" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("action.upload")), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: submitSuccess.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((submitSuccess).value = $event)),
        width: "500",
        title: "Bacth Detail",
        "align-center": "",
        "append-to-body": "",
        class: "rounded"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("fields.batchId")) + ": ", 1),
              _createElementVNode("span", null, _toDisplayString(successData.value.adjustBatchId), 1)
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("fields.totalAccountsUploaded")) + ": ", 1),
              _createElementVNode("span", null, _toDisplayString(successData.value.totalAccounts), 1)
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("fields.accountsInOurSystem")) + ": ", 1),
              _createElementVNode("span", null, _toDisplayString(successData.value.accountsInOurSystem), 1)
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(_toDisplayString(_ctx.$t("title.totalAmount")) + ": ", 1),
              _createVNode(BalanceShow, {
                balance: successData.value.totalAmount
              }, null, 8, ["balance"])
            ])
          ]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "danger",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (close()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (process())),
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.confirmToProcess")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})